import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function PublicFullLayout({ children }: Props) {
  return (
    <>
      {/* <Header /> */}

      <Container
        component="div"
        sx={{
          width: '100% !important',
        }}
        maxWidth={false} // Override MUI's maxWidth
        disableGutters // Remove the padding around the Container
      >
        <Stack
          sx={{
            // py: 12,
            // m: 'auto',
            width: '100%',
            // minHeight: '100vh',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
}
